<template>
  <div class="buy-guide">
    <header-bar></header-bar>

    <!-- 页头横幅 -->
    <section class="banner">
      <img
        class="banner-bg"
        :src="require('@/assets/banner_neural.jpg')"
        alt="般意品牌蓝色神经网络背景"
      />
      <div class="banner-mask"></div>
      <div class="banner-content">
        <h1 class="banner-title">购买指引</h1>
        <p class="banner-subtitle">认准官方渠道，享受完整售后</p>
      </div>
    </section>

    <!-- 官方店铺 -->
    <section class="section store-section">
      <div class="store-card">
        <div class="store-info">
          <p class="store-platform">{{ purchase.tmallPlatform }}</p>
          <h2 class="store-name">
            {{ purchase.tmallPlatform }}「{{ purchase.tmallStoreName }}」
          </h2>
          <p class="store-desc">
            这是般意唯一的官方旗舰店，所有正品与官方售后均通过该店提供。
          </p>
          <div class="store-actions">
            <div class="store-actions-left">
              <a
                class="store-btn"
                :href="tmallUrlWithUtm"
                target="_blank"
                rel="noopener noreferrer"
                >前往天猫官方旗舰店</a
              >
              <p class="jd-note" v-if="!purchase.jdUrl">京东自营店筹备中</p>
              <a
                class="jd-link"
                v-else
                :href="purchase.jdUrl"
                target="_blank"
                rel="noopener noreferrer"
                >前往京东自营店</a
              >
            </div>
            <div class="store-qr">
              <img
                v-if="purchase.tmallQrAsset"
                :src="tmallQrImg"
                alt="天猫官方旗舰店二维码"
              />
              <div v-else class="qr-placeholder">店铺二维码即将上线</div>
            </div>
          </div>
        </div>
        <div class="store-art">
          <img
            :src="require('@/assets/headband_white.png')"
            alt="般意精力舱白色头环产品图"
          />
        </div>
      </div>
    </section>

    <!-- 在售型号与官方价格 -->
    <section class="section products-section">
      <h2 class="section-title">在售型号与官方价格</h2>
      <div class="product-list">
        <div class="product-card" v-for="item in products" :key="item.model">
          <div
            class="product-art"
            :class="'product-art-' + artOf(item.model).theme"
          >
            <img
              v-if="artOf(item.model).src"
              :src="artOf(item.model).src"
              :alt="item.model + ' ' + item.nickname"
            />
            <div v-else class="product-art-fallback">{{ item.model }}</div>
          </div>
          <div class="product-body">
            <h3 class="product-model">{{ item.model }}</h3>
            <p
              class="product-nickname"
              :class="'product-nickname-' + artOf(item.model).theme"
            >
              {{ item.nickname }}
            </p>
            <p class="product-position">{{ item.position }}</p>
            <p class="product-price">{{ item.priceBand }}</p>
            <router-link
              v-if="item.route"
              class="product-link"
              :to="item.route"
              >产品详情 →</router-link
            >
          </div>
        </div>
      </div>
    </section>

    <!-- 防伪说明 -->
    <section class="section antifake-section">
      <h2 class="section-title">防伪说明</h2>
      <div class="antifake-card">
        <p class="antifake-main">{{ purchase.antiFake }}</p>
        <p class="antifake-sub">
          收到产品后可通过天猫旗舰店客服或官方热线
          {{ contact.phone }} 验证真伪。
        </p>
      </div>
    </section>

    <!-- 售后承诺 -->
    <section class="section aftersale-section">
      <h2 class="section-title light">售后承诺</h2>
      <div class="aftersale-grid">
        <div
          class="aftersale-item"
          v-for="(item, index) in purchase.afterSale"
          :key="index"
        >
          <div class="aftersale-no">{{ ("0" + (index + 1)).slice(-2) }}</div>
          <div class="aftersale-text">{{ item }}</div>
        </div>
      </div>
    </section>

    <footer-info></footer-info>
  </div>
</template>

<script>
import headerBar from "@/components/common/HeaderBar";
import footerInfo from "@/components/common/FooterInfo";
import { purchase, products, contact } from "@/data/facts";

export default {
  components: {
    headerBar,
    footerInfo,
  },
  data() {
    return {
      purchase,
      products,
      contact,
      // 在售型号配图与主题色（老站视觉资产透明小图）
      productArt: {
        "LOTUS 2": {
          theme: "gold",
          src:
            require("@/assets/product_lotus2_small.png"),
        },
        "LOTUS 2R": {
          theme: "blue",
          src:
            require("@/assets/product_lotus2r_small.png"),
        },
        Lume: {
          theme: "purple",
          src: require("@/assets/lume_product.png"),
        },
        经颅直流电刺激仪: {
          theme: "blue",
          src: require("@/assets/headband_white.png"),
        },
      },
    };
  },
  computed: {
    tmallUrlWithUtm() {
      return this.purchase.tmallUrl + "&" + this.purchase.utm;
    },
    tmallQrImg() {
      return this.purchase.tmallQrAsset
        ? require("@/assets/" + this.purchase.tmallQrAsset)
        : "";
    },
  },
  methods: {
    artOf(model) {
      return this.productArt[model] || { theme: "gray", src: "" };
    },
  },
};
</script>

<style scoped>
.buy-guide {
  width: 100vw;
  background: #ffffff;
}

/* 页头横幅 */
.banner {
  position: relative;
  width: 100vw;
  height: 26vw;
  overflow: hidden;
}

.banner-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    rgba(10, 12, 60, 0.6) 0%,
    rgba(27, 30, 138, 0.28) 60%,
    rgba(27, 30, 138, 0.12) 100%
  );
}

.banner-content {
  position: relative;
  padding: 8.6vw 13.3vw 0 13.3vw;
}

.banner-title {
  font-size: 2.5vw;
  color: #ffffff;
  font-family: "SourceHanSansCN-Bold";
}

.banner-subtitle {
  margin-top: 1.3vw;
  font-size: 1.25vw;
  color: rgba(255, 255, 255, 0.85);
  font-family: "SourceHanSansCN-Medium";
}

/* 通用区块 */
.section {
  padding: 4.2vw 13.3vw;
}

.section-title {
  text-align: center;
  font-size: 2.5vw;
  color: #333333;
  font-family: "SourceHanSansCN-Bold";
  margin-bottom: 3.2vw;
}

.section-title.light {
  color: #ffffff;
}

/* 官方店铺 */
.store-section {
  background: #ffffff;
}

.store-card {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  border-radius: 1.2vw;
  overflow: hidden;
  box-shadow: 0 1vw 3vw rgba(27, 30, 138, 0.14);
  border: 0.05vw solid #e5e7f5;
}

.store-info {
  flex: 1;
  padding: 3.4vw 3vw;
}

.store-platform {
  display: inline-block;
  font-size: 0.85vw;
  color: #ffffff;
  background: #888ef9;
  border-radius: 0.3vw;
  padding: 0.25vw 0.8vw;
  font-family: "SourceHanSansCN-Medium";
}

.store-name {
  margin-top: 1.2vw;
  font-size: 1.9vw;
  color: #333333;
  font-family: "SourceHanSansCN-Bold";
}

.store-desc {
  margin-top: 1.2vw;
  font-size: 1vw;
  line-height: 1.9;
  color: #666666;
  font-family: "SourceHanSansCN-Regular";
  max-width: 34vw;
}

.store-actions {
  display: flex;
  align-items: flex-end;
  margin-top: 2vw;
}

.store-btn {
  display: inline-block;
  font-size: 1vw;
  color: #ffffff;
  background: #1b1e8a;
  border-radius: 2vw;
  padding: 0.9vw 2.6vw;
  font-family: "SourceHanSansCN-Medium";
  text-decoration: none;
}

.jd-note {
  margin-top: 1.2vw;
  font-size: 0.85vw;
  color: #999999;
  font-family: "SourceHanSansCN-Regular";
}

.jd-link {
  display: inline-block;
  margin-top: 1.2vw;
  font-size: 0.85vw;
  color: #1b1e8a;
  font-family: "SourceHanSansCN-Medium";
  text-decoration: none;
}

.store-qr {
  margin-left: 3vw;
}

.store-qr img {
  width: 8.5vw;
  height: 8.5vw;
  border-radius: 0.5vw;
}

.qr-placeholder {
  width: 8.5vw;
  height: 8.5vw;
  border: 0.1vw dashed #b9bde0;
  border-radius: 0.5vw;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 0.85vw;
  color: #999999;
  font-family: "SourceHanSansCN-Regular";
  padding: 0 1vw;
  box-sizing: border-box;
  background: #fafbff;
}

.store-art {
  width: 30vw;
  background: linear-gradient(135deg, #1b1e8a 0%, #888ef9 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.store-art img {
  width: 80%;
  object-fit: contain;
}

/* 在售型号与官方价格 */
.products-section {
  background: #f7f8fa;
}

.product-list {
  display: flex;
  justify-content: center;
  align-items: stretch;
}

.product-card {
  width: 22vw;
  margin: 0 0.9vw;
  background: #ffffff;
  border-radius: 1.04vw;
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid #e8e9f5;
  box-shadow: 0 0.3vw 1.2vw rgba(27, 30, 138, 0.05);
}

.product-card:hover {
  box-shadow: 0 0.6vw 2.2vw rgba(27, 30, 138, 0.14);
}

.product-art {
  width: 100%;
  height: 10.5vw;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-art-gold {
  background: linear-gradient(96deg, #fdf6e7 0%, #f3e2c4 100%);
}

.product-art-blue {
  background: linear-gradient(96deg, #eef1fa 0%, #d9e0f2 100%);
}

.product-art-purple {
  background: linear-gradient(135deg, #1b1e8a 0%, #888ef9 100%);
}

.product-art-purple img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-art-gray {
  background: linear-gradient(135deg, #4a4f6b 0%, #9aa0c3 100%);
}

.product-art-fallback {
  font-family: "SourceHanSansCN-Bold", sans-serif;
  font-size: 1.4vw;
  color: #ffffff;
  letter-spacing: 0.15vw;
}

.product-art img {
  width: 55%;
  height: 85%;
  object-fit: contain;
}

.product-body {
  padding: 1.6vw 1.8vw 2vw 1.8vw;
  text-align: center;
}

.product-model {
  font-size: 1.4vw;
  color: #333333;
  font-family: "SourceHanSansCN-Bold";
}

.product-nickname {
  display: inline-block;
  margin-top: 0.7vw;
  font-size: 0.9vw;
  color: #888ef9;
  background: rgba(136, 142, 249, 0.14);
  border-radius: 1.5vw;
  padding: 0.25vw 1vw;
  font-family: "SourceHanSansCN-Medium";
}

.product-nickname-gold {
  color: #a87e5f;
  background: rgba(181, 136, 100, 0.14);
}

.product-nickname-blue {
  color: #6b7cb5;
  background: rgba(107, 124, 181, 0.14);
}

.product-position {
  margin-top: 1vw;
  font-size: 0.95vw;
  color: #666666;
  font-family: "SourceHanSansCN-Regular";
}

.product-price {
  margin-top: 1vw;
  font-size: 0.95vw;
  line-height: 1.7;
  color: #333333;
  font-family: "SourceHanSansCN-Regular";
}

.product-link {
  display: inline-block;
  margin-top: 1.4vw;
  font-size: 0.95vw;
  color: #1b1e8a;
  font-family: "SourceHanSansCN-Medium";
  text-decoration: none;
}

/* 防伪说明 */
.antifake-section {
  background: #ffffff;
}

.antifake-card {
  background: #fffaf2;
  border-left: 0.45vw solid #e8a13c;
  border-radius: 0.8vw;
  padding: 2.4vw 3vw;
}

.antifake-main {
  font-size: 1.5vw;
  line-height: 1.8;
  color: #1b1e8a;
  font-family: "SourceHanSansCN-Bold";
}

.antifake-sub {
  margin-top: 1.4vw;
  font-size: 1vw;
  line-height: 1.9;
  color: #666666;
  font-family: "SourceHanSansCN-Regular";
}

/* 售后承诺 */
.aftersale-section {
  background: linear-gradient(90deg, #1b1e8a 0%, #2b2fa8 60%, #888ef9 130%);
}

.aftersale-grid {
  display: flex;
  justify-content: space-between;
}

.aftersale-item {
  width: 17vw;
  background: rgba(255, 255, 255, 0.08);
  border: 0.05vw solid rgba(255, 255, 255, 0.25);
  border-radius: 0.8vw;
  padding: 2vw 1vw;
  text-align: center;
  box-sizing: border-box;
}

.aftersale-no {
  font-size: 1.9vw;
  color: rgba(255, 255, 255, 0.35);
  font-family: "SourceHanSansCN-Bold";
}

.aftersale-text {
  margin-top: 0.8vw;
  font-size: 1.05vw;
  color: #ffffff;
  font-family: "SourceHanSansCN-Medium";
}
</style>



// WEBPACK FOOTER //
// src/components/pages/BuyGuide.vue